'use client'
import React from 'react'
import { FarminstaCopyLayout, PandoforceLayout } from './home/layout'
import { Button } from '@/components/ui/button';
import { useRouter } from 'next/navigation';
import heroImg from '../../public/images/WebsiteImages/Hero.png'
import heroImage_pando from '../../public/images/WebsiteImages/heroImage_pando.png'
import Image from 'next/image';
import image2 from '../../public/images/WebsiteImages/home/2.svg'
import { ArrowUpRight, Rocket, DollarSign, Target, BarChart2, Award, Check, Trophy, Filter, Star } from 'lucide-react'
import { Avatar, AvatarFallback } from '@/components/ui/avatar';
import udayImg from '../../public/images/WebsiteImages/home/UdayKumar.png'
import purna from '../../public/images/WebsiteImages/home/PurnaChandraRao.jpg'
import arun from '../../public/images/WebsiteImages/home/ArunSoni.jpeg'
import AnimatedSection from '../home/animated-section';

interface FeatureProps {
  icon: React.ElementType
  title: string
  description: string
}


export const PfHeroSection: React.FC = () => {
    const router = useRouter();
    // const [user]= useUser();

    const handleDemo = () => {
        router.push("/pandoforce/pricing")
    }
    return (
        <section className="bg-[#ebf2f0] py-8 px-4 sm:px-6 lg:px-8 mt-10">
            <div className="max-w-7xl mx-auto">
                <div className="flex flex-col lg:flex-row lg:items-center lg:justify-between gap-12">
                    <div className="lg:w-[45%]">
                        <h1 className="text-2xl sm:text-3xl lg:text-4xl   font-bold text-gray-900 mb-4 leading-tight">
                            Track Your Field Force, Engage Every Customer, Drive More Sales

                        </h1>
                        <p className="text-base sm:text-lg text-gray-600 mb-8 leading-relaxed">
                            Digitize your sales officer activities, enhance dealer engagement, and capture real-time insights
                        </p>
                        <div className="grid grid-cols-3 gap-6 mb-8">
                            <div className="text-center">
                                <p className="text-xl sm:text-2xl font-bold text-gray-900 mb-1">15 M</p>
                                <p className="text-l text-gray-600">Sales Activities</p>
                            </div>
                            <div className="text-center">
                                <p className="text-xl sm:text-2xl font-bold text-gray-900 mb-1">600 K</p>
                                <p className="text-l text-gray-600">Locations Connected</p>
                            </div>
                            <div className="text-center">
                                <p className="text-xl sm:text-2xl font-bold text-gray-900 mb-1">1.5 M</p>
                                <p className="text-l text-gray-600">Customers Served</p>
                            </div>
                        </div>
                        {/* <Button className="bg-[#35a4a6] text-white hover:bg-[#35a4a6]" onClick={handleDemo}>
                            Get Started Now
                        </Button> */}
                    </div>

                    <div className="lg:w-[55%] flex justify-end">
                        <div className="relative w-full">
                            <Image
                                className="w-full h-auto min-h-[400px] max-h-[500px] object-contain object-center ml-8"
                                src={heroImage_pando}
                                alt="customers and business professionals"
                            />
                        </div>
                    </div>
                </div>
            </div>
        </section>
    )
}

export const PfFeaturesSection = () => (
    <section className="py-12 px-6 bg-white">
      <div className="max-w-5xl mx-auto">
        <h2 className="text-4xl font-bold mb-4 text-gray-900 text-center">
        The only sales officer platform you need
        </h2>
        <div className='flex flex-col items-center justify-center  mb-12'>
          <p className="text-xl text-gray-600 text-center max-w-3xl mx-auto">
          Helping Businesses Scale Field Campaigns
          </p>
          <p className="text-xl text-gray-600  text-center max-w-3xl mx-auto">
          & maximize ROI
          </p>
        </div>


        <div className="grid md:grid-cols-3 gap-8">
          <div className="bg-white rounded-2xl p-8 border border-gray-100 shadow-[rgba(17,_17,_26,_0.1)_0px_0px_16px]">
            <h3 className="text-xl font-bold mb-4 text-gray-900">
              Monitor<br />
              Sales Officer Productivity
            </h3>
            <p className="text-gray-600">
              Track and manage sales productivity - monitor activities, attendance & customer outreact numbers.
            </p>
          </div>

          <div className="bg-white rounded-2xl p-8 border border-gray-100 shadow-[rgba(17,_17,_26,_0.1)_0px_0px_16px]">
            <h3 className="text-xl font-bold mb-4 text-gray-900">
              Leverage In-built<br />
              Customer CRM
            </h3>
            <p className="text-gray-600">
              Get detailed history of customers and category data, enabling you and your team to build campaigns to success.
            </p>
          </div>

          <div className="bg-white rounded-2xl p-8 border border-gray-100 shadow-[rgba(17,_17,_26,_0.1)_0px_0px_16px]">
            <h3 className="text-xl font-bold mb-4 text-gray-900">
            Drive <br/>
            Smarter Decisions
            </h3>
            <p className="text-gray-600">
            Visualize sales officer productivity, campaign success rates, and customer responses — all in real-time.

            </p>
          </div>
        </div>
      </div>
    </section>
  )

 export const PfOperationsSection = () => (
    <section className="py-12 px-6 bg-[#ebf2f0]">
      <div className="max-w-6xl mx-auto flex flex-col md:flex-row items-center gap-12">
        <div className="md:w-1/2">
          <h2 className="text-2xl sm:text-3xl font-bold mb-8 text-gray-900 leading-tight">
            Streamline Sales Officer Operations for Success
          </h2>
          <div>
            <p className='mb-4'>Manage your resources efficiently and optimize sales officer operations, allowing sales officers to focus on driving better sales and achieve campaign success. Enable efficient visits and push the right products to enhance yield. </p>
          </div>
          <ul className="space-y-6">
            {[
              {
                title: "Monitor Activities ",
                description: "Effortlessly manage your sales activities and monitor team performance. Keep campaign effectiveness in check and identify trends to plan ahead. "
              },
              {
                title: "Digitized Consultations",
                description: "Save time, resources, and reduce costs with Pandoforce expert digital approach - ensure customers receive timely and accurate consultations. "
              },
              {
                title: "Liquidation Tracking",
                description: "Manage product placements by tracking inventory at dealer’s end. Track progress and drive sales effectively."
              }
            ].map((item, index) => (
              <li key={index} className="flex items-start">
                <div className="bg-[#35a4a6] rounded-full p-1.5 mr-4 mt-1 shrink-0">
                  <Check className="w-3.5 h-3.5 text-white" />
                </div>
                <div>
                  <h3 className="font-semibold text-lg mb-1 text-gray-900">{item.title}</h3>
                  <p className="text-gray-600 leading-relaxed">{item.description}</p>
                </div>
              </li>
            ))}
          </ul>
        </div>
        <div className="md:w-1/2 flex justify-center">
          <div className="relative w-full max-w-md">
            <Image
              src={image2}
              alt="Field Operations Illustration"
              width={650}
              height={650}
              className="w-full h-auto"
            />
          </div>
        </div>
      </div>
    </section>
  )

  const Feature: React.FC<FeatureProps> = ({ icon: Icon, title, description }) => (
    <div className="bg-white rounded-2xl p-6 shadow-sm hover:shadow-md transition-shadow">
      <div className="w-12 h-12 bg-green-100 rounded-xl flex items-center justify-center mb-4">
        <Icon className="w-6 h-6 text-green-600" />
      </div>
      <h3 className="text-xl font-semibold text-gray-900 mb-3 leading-tight">
        {title}
      </h3>
      <p className="text-gray-600 leading-relaxed">
        {description}
      </p>
    </div>
  )

 export const PfCampaignHubFeatures: React.FC = () => {
    const features: FeatureProps[] = [
      {
        icon: ArrowUpRight,
        title: "Streamline market expansion",
        description: "Breakthrough new districts and locations effortlessly. Leverage digital solutions to accelerate expansion efforts."
      },
      {
        icon: Rocket,
        title: "Elevate brand with modern marketing tools",
        description: "Boost brand visibility with short form videos and reels. Spread brand awareness and capture customers' attention."
      },
      {
        icon: DollarSign,
        title: "Maximize growth and reduce costs",
        description: "Cut marketing costs and fuel growth with digital campaign models that deliver triple the impact while optimizing the budget."
      },
      {
        icon: Filter,
        title: "Build loyalty with CRM tools",
        description: "Cultivate loyalty and enhance engagement with inbuilt customer CRM that enables personalized interactions and strengthens customer relationships."
      },
      {
        icon: BarChart2,
        title: "Enhance ROI with data-driven strategies",
        description: "Harness in-depth customer insights to make data-driven decisions. Allocate resources and maximize ROI with precision."
      },
      {
        icon: Trophy,
        title: "Inspire and Reward",
        description: "Empower customers with streamlined points system to reward engagement and loyalty to build long-term lucrative relationships."
      }
    ]

    return (
      <section className="mt-12">
        <div className="mx-auto">
          <div className="bg-white md:p-16 sm:p-10">
            <h2 className="text-2xl sm:text-3xl font-bold text-gray-900 mb-6 text-center">
              Drive growth with Pandoforce Campaign Hub
            </h2>

            <div className="grid md:grid-cols-2 gap-x-16 gap-y-12 w-[82%] mx-auto">
              {features.map((feature, index) => (
                <div key={index} className="flex gap-4">
                  <div className="mt-1">
                    <feature.icon className="w-5 h-5 text-[#35a4a6]" />
                  </div>
                  <div>
                    <h3 className="text-xl font-semibold text-gray-900 mb-2">
                      {feature.title}
                    </h3>
                    <p className="text-gray-600 leading-relaxed">
                      {feature.description}
                    </p>
                  </div>
                </div>
              ))}
            </div>
          </div>
        </div>
      </section>
    )
  }

 export const PfTestimonials = () => {
    const testimonials = [
      {
        rating: 5,
        text: "Pandoforce has transformed how I manage field operations. The digital platform has made reporting easier, communication more effective, and my overall workflow much more efficient",
        name: "Uday Kumar",
        role: "Field Officer- Advanta",
        initials: "UK",
        image: udayImg,
      },
      {
        rating: 5,
        text: "Pandoforce has been a game-changer for my farm. The advisory reels are invaluable, and the ability to connect with knowledgeable field officer.It's like having a support system right in my pocket!\"",
        name: "Purna Chandra Rao",
        role: "customer- Guntur, Andhrapradesh",
        initials: "PC",
        image: purna,
      },
      {
        rating: 5,
        text: "Pandoforce has transformed the way we approach agri-marketing. The real-time market data access have given seasonal insights and comparative analysis. Our campaigns are now more targeted.",
        name: "Arun soni",
        role: "ZM- Savannah Seeds",
        initials: "AS",
        image: arun,
      }
    ]

    return (
      <section className="py-12 px-4 sm:px-6 lg:px-8">
        <div className="max-w-7xl mx-auto">
          <div className="text-center mb-6">
            <h2 className="text-3xl sm:text-4xl font-bold text-gray-900">
              Check our clients feedback!
            </h2>
          </div>

          <div className="grid md:grid-cols-3 gap-8">
            {testimonials.map((testimonial, index) => (
              <div
                key={index}
                className="bg-white rounded-2xl p-8 shadow-[rgba(17,_17,_26,_0.1)_0px_0px_16px]"
              >
                <div className="flex mb-4">
                  {[...Array(testimonial.rating)].map((_, i) => (
                    <Star
                      key={i}
                      className="w-5 h-5 fill-yellow-400 text-yellow-400"
                    />
                  ))}
                </div>

                <p className="text-gray-900 mb-6 leading-relaxed">
                  {testimonial.text}
                </p>

                <div className="flex items-center gap-3">
                  <Avatar className="h-12 w-12 relative">
                    {testimonial.image ? (
                      <Image
                        src={testimonial.image}
                        alt={testimonial.name}
                        className="rounded-full"
                      />
                    ) : (
                      <AvatarFallback className="bg-gray-100 text-gray-600">
                        {testimonial.initials}
                      </AvatarFallback>
                    )}
                  </Avatar>
                  <div>
                    <h3 className="font-semibold text-gray-900">
                      {testimonial.name}
                    </h3>
                    <p className="text-sm text-gray-500">
                      {testimonial.role}
                    </p>
                  </div>
                </div>
              </div>
            ))}
          </div>
        </div>
      </section>
    )
  }

 export const PfStatsSection = () => (
    <section className=" px-6 mt-10">
      <div className="max-w-4xl mx-auto text-center">
        <h2 className="text-3xl font-bold mb-8">Our 2023 data tells the success stories</h2>
        <div className="flex justify-center space-x-12">
          <div>
            <div className="text-4xl font-bold text-[#35a4a6]">6 M</div>
            <div className="text-gray-600">Customers Reached</div>
          </div>
          <div>
            <div className="text-4xl font-bold text-[#35a4a6]">300 K</div>
            <div className="text-gray-600">Customers Engaged</div>
          </div>
          <div>
            <div className="text-4xl font-bold text-[#35a4a6]">2 M</div>
            <div className="text-gray-600">Acres Mapped</div>
          </div>
        </div>
      </div>
    </section>
  )



const Page = () => {
    return (
        <PandoforceLayout currentPage='home' >
            <PfHeroSection />
            <PfFeaturesSection/>
            <AnimatedSection>
            <PfOperationsSection/>
            </AnimatedSection>
            <AnimatedSection>
            <PfCampaignHubFeatures/>
            </AnimatedSection>
            {/* <AnimatedSection>
            <PfTestimonials/>
            </AnimatedSection> */}
        </PandoforceLayout>
    )
}

export default Page
